import { msalInstance } from "../core/authentication/entra/msal";

export async function signOutAdmin(): Promise<void> {
  sessionStorage.setItem("isAdminSessionExpired", "true");

  try {
    await msalInstance.logoutRedirect({
      postLogoutRedirectUri: `${window.location.origin}/admin`,
    });
  } catch {
    // hard redirect as a fallback
    window.location.href = "/admin";
  }
}
